const KpiCard = ({ label, value, icon, bgColor, iconBgcolor }) => {
  return (
    <div className={`flex flex-col rounded-lg w-1/4 p-3 gap-y-4 ${bgColor}`}>
      <div className={`rounded-full w-fit p-2 ${iconBgcolor}`}>{icon}</div>
      <div>
        <div className="text-sm font-semibold">{value}</div>
        <div className="text-base font-light">{label}</div>
      </div>
    </div>
  );
};

export default KpiCard;
